<template lang="pug">
    div(v-if="isLoading || validLlmAssessmentItems")
        v-card(v-if="isLoading" outlined)
            .text-center
                v-progress-circular(
                    :size='100'
                    :width='10'
                    color='var(--volie-blue)'
                    indeterminate
                    style="margin-top: 75px; margin-bottom: 75px;"
                )

        template(v-else-if="validLlmAssessmentItems")
            v-card(outlined).mb-4

                v-list(subheader two-line)
                    v-list-item(style="min-height: 28px;")
                        v-list-item-content.pt-5.pb-0
                            v-list-item-title(style="font-weight: 500;")
                                | Assessment

                .mt-4.px-4
                    LlmAssessmentItem(
                        v-for="(llmAssessmentItem, idx) in llmAssessmentItems"
                        :key="llmAssessmentItem.llm_assessment_item_id"
                        :llm-assessment="llmAssessment"
                        :llm-assessment-item="llmAssessmentItem"
                        :show-snackbar="showSnackbar"
                        skip-summary
                    )


</template>

<script lang="ts">
    import Vue from 'vue';

    // Data
    import { 
        GetLlmAssessmentItems,
    } from "@/data";

    // Components
    import LlmAssessmentItem from '@/components/scorecards/llm_assessment_item.vue';

    export default Vue.extend({
        data() {
            return {
                isLoading: false,
                llmAssessmentItems: [],
            }
        },
        methods: {
            getLlmAssessmentItems() {
                if (!this.validLlmAssessment) {
                    return;
                }

                const options = {
                    llm_assessment_id: this.scorecard.llm_assessment.llm_assessment_id,
                }

                this.isLoading = true;
                GetLlmAssessmentItems(options).then((response) => {
                    if (response?.Data?.llm_assessment_items?.length > 0) {
                        this.llmAssessmentItems = response.Data.llm_assessment_items;

                        for (let i = 0; i < this.llmAssessmentItems.length; i++) {
                            if (this.llmAssessmentItems[i]?.llm_assessment_type === 'summary') {
                                this.$emit('summaryLlmAssessmentItem', this.llmAssessmentItems[i]);
                            }
                        }
                    }

                    this.isLoading = false;
                });
            },
            init() {
                if (this.validLlmAssessment) {
                    this.getLlmAssessmentItems();
                }

                return;
                
            },
        },
        computed: {
            llmAssessment() {
                return this.scorecard?.llm_assessment;
            },
            validLlmAssessment() {
                return this.scorecard?.llm_assessment?.llm_assessment_id > 0 && this.scorecard.llm_assessment.valid_for_analytics === true && this.scorecard.llm_assessment.status === 'complete';
            },
            validLlmAssessmentItems() {
                return this.llmAssessmentItems?.length > 0;
            },
            validScorecard() {
                return this.scorecard?.scorecard_id > 0;
            },
        },
        components: {
            LlmAssessmentItem,
        },
        props: {
            scorecard: Object,
            showSnackbar: Function,
        },
        created() {
            this.init();
        },
    });
</script>

<style lang="scss" scoped>
    #app {

    }
</style>
